/**
 * No-op analytics provider. Returned by the factory when:
 *   - the configured search provider has no matching analytics implementation
 *     (e.g. `mock`, `unbxd`, `algolia`, `shopify` for now);
 *   - tests need to assert "no analytics call happened" without mocking the
 *     network layer;
 *   - analytics is intentionally disabled for a build.
 *
 * Every method is a no-op. Call sites stay platform-agnostic — they don't need
 * to check whether analytics is configured.
 */
export class NullAnalyticsProvider {
    trackViewItemList(_event) { }
    trackSelectItem(_event) { }
    trackAddToCart(_event) { }
    trackSearch(_event) { }
    trackSelectFilter(_event) { }
    trackSearchSuggested(_event) { }
}
